/**
* 角色权限
*/
const role = {
  
createRole: "/api/createRole",//创建
modifyRole: "/api/modifyRole",//修改
deleteRole: "/api/deleteRole",//删除
getRoleInfo: "/api/getRoleInfo",//查询角色信息
getRolesInfos: "/api/getRolesInfos",//查询角色信息
getChildrenOfRole: "/api/getChildrenOfRole",//查询角色的子角色
modifyRolePrivilegeForPage: "/api/modifyRolePrivilegeForPage",//修改页面权限
getRolePrivilegeForPage: "/api/getRolePrivilegeForPage",//获取页面权限
modifyRolePrivilegeForMeasure: "/api/modifyRolePrivilegeForMeasure",//修改数据权限
getRolePrivilegeForMeasure: "/api/getRolePrivilegeForMeasure",//获取数据权限
modifyRolePrivilegeForORGStruct: "/api/modifyRolePrivilegeForORGStruct",//修改数据权限
getRolePrivilegeForORGStruct: "/api/getRolePrivilegeForORGStruct",//获取数据权限
modifyRolePrivilegeForOperation: "/api/modifyRolePrivilegeForOperation",//修改操作权限
getRolePrivilegeForOperation: "/api/getRolePrivilegeForOperation",//获取操作权限
listOperationDefinesOfRolePrivilege: "/api/listOperationDefinesOfRolePrivilege",//列出所有权限操作
}

export default role